import moment from "moment"

export function setupJobDayPrefillData(jobDay) {

    let prefillData = {...jobDay}

    // crew Assignments
    let assignments = []
    jobDay.crewMemberAssignments.forEach(assignment => {

        const item = {
            id: assignment.id,
            crewMember: assignment.crewMember.id,
            firstName: assignment.crewMember.firstName,
            lastName: assignment.crewMember.lastName,
            classification: assignment.crewMember.classification
        }

        assignments.push(item)
    })
    prefillData['crewAssignments'] = [...assignments]

    // job
    prefillData['job'] = jobDay.job.id
    prefillData['driver'] = jobDay.driver ? jobDay.driver.id : ''
    prefillData['truck'] = jobDay.truck ? jobDay.truck.id : ''
    prefillData['driver2'] = jobDay.driver2 ? jobDay.driver2.id : ''
    prefillData['truck2'] = jobDay.truck2 ? jobDay.truck2.id : ''
    prefillData['driver3'] = jobDay.driver3 ? jobDay.driver3.id : ''
    prefillData['truck3'] = jobDay.truck3 ? jobDay.truck3.id : ''
    prefillData['vehicleOption'] = jobDay.vehicleOption || ''  // ADD THIS LINE
    prefillData['startTime'] = jobDay.startTime ? moment(`12/12/12 ${jobDay.startTime}`) : null
    prefillData['endTime'] = jobDay.endTime ? moment(`12/1/22 ${jobDay.endTime}`) : null

    return prefillData
}